import { ensureModelObjectId } from '../ControlDesigner/controlDesignerSelectionSync.js';

/**
 * Registers designer components with ControlDesigner_v3 for tree-to-designer selection sync.
 * Use on designer controls that do not already mix in BaseComponentMixin.
 */
export default {
    mounted() {
        this._registerWithDesignerRoot();
    },
    updated() {
        this._registerWithDesignerRoot();
    },
    unmounted() {
        this.root?.unregisterDesignerComponent?.(this);
    },
    methods: {
        _registerWithDesignerRoot() {
            if (this.designmodel)
                ensureModelObjectId(this.designmodel);
            this.root?.registerDesignerComponent?.(this);
        },
    },
};
